export enum SlingStatus {
    OK = 'OK',
    PENDING_UP = 'PENDING_UP',
    PENDING_DOWN = 'PENDING_DOWN',
    CANCELED = 'CANCELED',
    WATER = 'WATER',
}
